import { common } from './common.icons';

export const IconLock = ({ className = '', style = {}, ...rest }: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={`icon-lock ${common.classes} ${className}`}
      {...rest}
      style={{ ...common.styles, ...style }}
      viewBox="0 0 14 16"
      strokeWidth="2"
      stroke="currentColor"
      fill="none"
      strokeLinecap="round"
    >
      <path d="M3.66667 7.00048V4.3336C3.66667 3.44947 4.01786 2.60156 4.64298 1.97639C5.2681 1.35122 6.11595 1 7 1C7.88406 1 8.7319 1.35122 9.35702 1.97639C9.98214 2.60156 10.3333 3.44947 10.3333 4.3336V7.00048M2.33333 7.00048H11.6667C12.403 7.00048 13 7.59748 13 8.33392V13.001C13 13.7374 12.403 14.3344 11.6667 14.3344H2.33333C1.59695 14.3344 1 13.7374 1 13.001V8.33392C1 7.59748 1.59695 7.00048 2.33333 7.00048Z" />
    </svg>
  );
};
